import { setSelectedSettingsLocations } from './chunk-JMA3A6L2.mjs';
import { selectShouldRenderLocationDropdown, areSettingsMasterModeSelector } from './chunk-PHOCK55S.mjs';

// src/helpers/settings/modals/selectSettingsLocationModal.ts
var shouldShowSettingsLocationsModalOnSaveCore = (dispatch, state) => {
  const { changeData } = state.settings;
  const { settingsSelected } = changeData;
  const userLocations = state.loggedInUser.settingsAccessLocations;
  const hasMultipleLocations = selectShouldRenderLocationDropdown(state);
  const isMasterMode = areSettingsMasterModeSelector(state);
  dispatch(setSelectedSettingsLocations([]));
  if (!settingsSelected)
    return false;
  let updatableLocations = [...userLocations];
  if (settingsSelected === "users") {
    const updatedUser = state.settings.changeData.data;
    const userId = updatedUser.id;
    const masterUser = state.settings.master.users[userId || -1];
    if (masterUser) {
      const masterUserAccessLocationSet = new Set(
        (masterUser == null ? void 0 : masterUser.locationIds) || []
      );
      updatableLocations = userLocations.filter(
        (locationId) => masterUserAccessLocationSet.has(locationId)
      );
    }
  }
  const skipLocationModal = /* @__PURE__ */ new Set([
    "printerRules",
    "licenseSettings"
  ]);
  if (skipLocationModal.has(settingsSelected))
    return false;
  if (!isMasterMode && updatableLocations.length === 1) {
    dispatch(setSelectedSettingsLocations(updatableLocations));
    return false;
  }
  if (!hasMultipleLocations && isMasterMode) {
    dispatch(setSelectedSettingsLocations([0, ...updatableLocations]));
    return false;
  }
  if (updatableLocations.length > 0) {
    return true;
  }
  return false;
};

export { shouldShowSettingsLocationsModalOnSaveCore };
